import React, { useEffect, useMemo, useRef } from 'react';

import { Box, SxProps, Theme } from '@mui/material';
import QRCodeStyling, { DotType } from 'qr-code-styling';

import DSIcon from './../../datascope-icon.png';

const customStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'inline-block',
    justifyContent: 'center',
  },
  qrContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const defaultQrStyles = {
  dotsColor: '#000000',
  dotsType: 'rounded' as DotType,
  backgroundColor: '#FFFFFF',
  cornersColor: '#000000',
  width: 320,
  height: 320,
  margin: 16,
};

interface QrCodeStylingComponentProps {
  data: string;
  qrStyles?: {
    dotsColor?: string;
    dotsType?: DotType;
    backgroundColor?: string;
    cornersColor?: string;
    width?: number;
    height?: number;
    margin?: number;
  };
  showLogo?: boolean;
}

function QrCodeStylingComponent({ data, qrStyles, showLogo = true }: QrCodeStylingComponentProps) {
  const ref = useRef<HTMLDivElement>(null);

  const qrCodeInstance = useMemo(() => {
    return new QRCodeStyling({
      image: showLogo ? DSIcon : undefined,
      width: qrStyles?.width || defaultQrStyles.width,
      height: qrStyles?.height || defaultQrStyles.height,
      margin: qrStyles?.margin || defaultQrStyles.margin,
      dotsOptions: {
        color: qrStyles?.dotsColor || defaultQrStyles.dotsColor,
        type: qrStyles?.dotsType || defaultQrStyles.dotsType,
      },
      imageOptions: {
        crossOrigin: 'anonymous',
        margin: 10,
      },
      backgroundOptions: {
        color: qrStyles?.backgroundColor || defaultQrStyles.backgroundColor,
      },
      cornersSquareOptions: {
        color: qrStyles?.cornersColor || defaultQrStyles.cornersColor,
      },
    });
  }, [qrStyles, showLogo]);

  useEffect(() => {
    if (ref.current && data) {
      ref.current.innerHTML = '';
      qrCodeInstance.append(ref.current);
      qrCodeInstance.update({ data });
    }
  }, [qrCodeInstance, data]);

  if (!data) {
    return null;
  }

  return (
    <Box sx={customStyles.container}>
      <Box sx={customStyles.qrContainer}>
        <div ref={ref} />
      </Box>
    </Box>
  );
}

export default QrCodeStylingComponent;
